module.exports = __webpack_public_path__ + "static/img/logo.b127664.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lekkerhot/logo.png
// module id = jpz7
// module chunks = 0